import { Box, Text, useBreakpoint } from '@factorialco/deprecated-design-system'
import { BillingAddonReferenceFragment, UpsellLandingPage } from 'generated/resources/graphql'

import { OneLandingButton } from 'modules/upsell/components/OneLanding/Button'
import FeaturesSection, {
  GradientMediaContainer,
} from 'modules/upsell/pages/OneLanding/_Sections/FeaturesSection'
import { MediaSection } from 'modules/upsell/pages/OneLanding/_Sections/MediaSection'

const MediaBox = ({ src }: { src: string | null | undefined }) => {
  const isVideo = src?.match(/\.(mp4|webm|ogg|mov|avi)$/i)

  return (
    <GradientMediaContainer maxWidth="500px">
      <Box borderRadius={{ all: 'abs016' }} overflowX="hidden" className="w-full md:w-1/2">
        {isVideo ? (
          <video
            src={src || ''}
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '280px',
              display: 'block',
              borderRadius: '14px',
            }}
            autoPlay
            muted
            loop
          />
        ) : (
          <img
            src={src || ''}
            alt=""
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '280px',
              display: 'block',
              borderRadius: '14px',
            }}
          />
        )}
      </Box>
    </GradientMediaContainer>
  )
}

const TextBox = ({
  title,
  description,
  buttonLabel,
  billingAddon,
  moduleName,
  index,
  alreadyInOneWaitlist,
}: {
  title: string | null | undefined
  description: string | null | undefined
  buttonLabel: string | null | undefined
  billingAddon: BillingAddonReferenceFragment | null
  moduleName: string
  index: number
  alreadyInOneWaitlist: boolean
}) => (
  <Box
    gap="s16"
    className="w-full md:w-[30%] px-6"
    alignItems="flexStart"
    padding="s40"
    maxWidth="s600"
  >
    {title && (
      <Text size="400" weight="semibold" color="black">
        {title || ''}
      </Text>
    )}
    {description && <Text size="300">{description || ''}</Text>}
    {buttonLabel && !alreadyInOneWaitlist && (
      <OneLandingButton
        buttonLabel={buttonLabel}
        variant="secondary"
        billingAddon={billingAddon}
        moduleName={moduleName}
        componentName={`feat-${index + 1}`}
      />
    )}
  </Box>
)

const Sections = ({
  content,
  billingAddon,
  moduleName,
  alreadyInOneWaitlist,
}: {
  content: UpsellLandingPage | undefined
  billingAddon: BillingAddonReferenceFragment | null
  moduleName: string
  alreadyInOneWaitlist: boolean
}) => {
  const { isMobile } = useBreakpoint()
  return (
    <Box gap="s40" padding="s80">
      {content?.sections.map((section, index) => {
        const isEven = index % 2 === 0

        if (section.type === 'TitleDescriptionFeaturesMediaActionRecord') {
          return (
            <FeaturesSection
              section={section}
              key={section.title}
              billingAddon={billingAddon}
              moduleName={moduleName}
              alreadyInOneWaitlist={alreadyInOneWaitlist}
              content={content}
            />
          )
        } else if (section.type === 'TitleDescriptionActionMediaurlRecord') {
          return <MediaSection content={section} key={section.title} />
        } else {
          if (isMobile) {
            return (
              <Box className="flex items-center flex-col" gap="s40" key={section.title}>
                <MediaBox src={section.media?.url} />
                <TextBox
                  title={section.title}
                  description={section.description}
                  buttonLabel={section.buttonLabel}
                  billingAddon={billingAddon}
                  moduleName={moduleName}
                  index={index}
                  alreadyInOneWaitlist={alreadyInOneWaitlist}
                />
              </Box>
            )
          } else {
            return (
              <Box
                className="flex items-center flex-row justify-center"
                gap="s40"
                key={section.title}
              >
                {isEven ? (
                  <>
                    <MediaBox src={section.media?.url} />
                    <TextBox
                      title={section.title}
                      description={section.description}
                      buttonLabel={section.buttonLabel}
                      billingAddon={billingAddon}
                      moduleName={moduleName}
                      index={index}
                      alreadyInOneWaitlist={alreadyInOneWaitlist}
                    />
                  </>
                ) : (
                  <>
                    <TextBox
                      title={section.title}
                      description={section.description}
                      buttonLabel={section.buttonLabel}
                      billingAddon={billingAddon}
                      moduleName={moduleName}
                      index={index}
                      alreadyInOneWaitlist={alreadyInOneWaitlist}
                    />
                    <MediaBox src={section.media?.url} />
                  </>
                )}
              </Box>
            )
          }
        }
      })}
    </Box>
  )
}

export default Sections
